import React, { useState } from "react";
import Billing from "./Billing";
import CartSummary from "./CartSummary";
import PaymentDetails from "./PaymentDetails";
import Coupon from "./Coupon";

function CheckoutDetails({ ...props }) {
  const { plan } = props;
  const [billingInfo, setBillingInfo] = useState({});
  const [couponAmount, setCouponAmount] = useState(0);
  const [couponId, setCouponId] = useState(null);
  // console.log("checkout got plan");
  // console.dir(plan);
  return (
    <div
      style={{
        padding: "30px 25px",
      }}
    >
      <h2>Checkout</h2>
      <div
        style={{
          display: "flex",
          padding: "20px 0px",
        }}
      >
        <div
          style={{
            marginRight: "30px",
          }}
        >
          <Billing
            style={{
              margin: "0px 0px 30px 0px",
              width: "837px",
            }}
            passStateToParent={setBillingInfo}
          />
          <PaymentDetails
            style={{
              height: "385px",
              width: "838px",
            }}
            billingInfo={billingInfo}
            couponId={couponId}
            {...props}
            plan={plan}
          />
        </div>
        <div>
          <CartSummary
            style={{
              width: "511px",
            }}
            couponAmount={couponAmount}
            plan={plan}
          />
          <Coupon setCouponAmount={setCouponAmount} setCouponId={setCouponId} />
        </div>
      </div>
    </div>
  );
}

export default CheckoutDetails;
